var shuffleSeed = require('shuffle-seed')

export function shuffler(array, seed) {
    let shuffledArray = shuffleSeed.shuffle(array, seed)
    return shuffledArray
}
